import * as React from "react";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useCopy } from "@/i18n/LocaleContext";

const COPY = {
  en: {
    title: "Schedule Service",
    frameTitle: "Schedule service with Axle Inc."
  },
  es: {
    title: "Programar servicio",
    frameTitle: "Programar servicio con Axle Inc."
  }
};

export function ScheduleServiceDialog({ children }: { children: React.ReactNode }) {
  const t = useCopy(COPY);

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-w-5xl w-[95vw] h-[88vh] p-0 overflow-hidden gap-0 sm:rounded-lg">
        <DialogTitle className="sr-only">{t.title}</DialogTitle>
        <iframe
          src="https://axle.setmore.com/"
          title={t.frameTitle}
          className="w-full h-full border-0 block"
          allow="payment; clipboard-write"
        />
      </DialogContent>
    </Dialog>
  );
}
